@let sensitiveData = this.sensitiveData();

<div class="bcb-line"></div>

<dl class="bcb-list">
  <div class="bcb-row bcb-card-number">
    <dt>{{ "cardView.bankCard.back.cardNumber" | translate }}</dt>
    @if (!isLoading()) {
      @if (!isSensitiveDataHidden()) {
        <dd>
          {{ sensitiveData?.number | cardNumber }}
          <iw-button
            size="s"
            class="bcb-copy"
            uiType="custom"
            (click)="copy(sensitiveData?.number, 'cardNumber', $event)"
          >
            <fu-icon iconName="copy" size="16" />
          </iw-button>
        </dd>
      } @else {
        <dd>•••• •••• •••• ••••</dd>
      }
    } @else {
      <iw-shimmer count="1" height="18" />
    }
  </div>
  <div class="bcb-row">
    <dt>{{ "cardView.bankCard.back.expireDate" | translate }}</dt>
    @if (!isLoading()) {
      @if (!isSensitiveDataHidden()) {
        @let expiryDate = sensitiveData?.validTill | date: "MM/yy" : "utc";
        <dd (click)="copy(expiryDate, 'expireDate', $event)">
          {{ expiryDate }}
          <iw-button
            size="s"
            uiType="custom"
            class="bcb-copy"
            (click)="copy(expiryDate, 'expireDate', $event)"
          >
            <fu-icon iconName="copy" size="16" />
          </iw-button>
        </dd>
      } @else {
        <dd>•• / ••</dd>
      }
    } @else {
      <iw-shimmer count="1" height="18" />
    }
  </div>
  <div class="bcb-row bcb-cvc">
    <dt>
      {{ "cardView.bankCard.back.cvc" | translate }}
    </dt>

    @if (!isLoading()) {
      @if (!isSensitiveDataHidden()) {
        <dd>
          {{ sensitiveData?.cvn }}
          <iw-button
            size="s"
            class="bcb-copy"
            uiType="custom"
            (click)="copy(sensitiveData?.cvn, 'cvc', $event)"
          >
            <fu-icon iconName="copy" size="16" />
          </iw-button>
        </dd>
      } @else {
        <dd>•••</dd>
      }
    } @else {
      <iw-shimmer count="1" height="18" />
    }
  </div>
</dl>

<iw-button
  [disabled]="!sensitiveData"
  size="s"
  uiType="custom"
  class="bcb-copy eye"
  (click)="$event.stopPropagation(); toggleSensitiveData()"
>
  <fu-icon
    [iconName]="isSensitiveDataHidden() ? 'eye-closed' : 'eye'"
    size="16"
  />
</iw-button>
